import React from "react";
import { Switch, FormControlLabel } from "@mui/material";

/**
 * A toggle button component that provides a compact way to toggle between two states.
 *
 * @prop {string} label The label to display next to the toggle button.
 * @prop {boolean} required Whether the field is required.
 * @prop {boolean} checked The current checked state of the toggle button. If not provided, the toggle button will be uncontrolled.
 * @prop {boolean} disabled Whether the toggle button is disabled.
 * @prop {function} onToggleChange The function to call when the toggle button is changed.
 * @prop {object} style Additional styles to apply to the toggle button.
 */
export const ToggleButton = ({
  label = "",
  required = false,
  checked = false,
  disabled = false,
  onToggleChange = () => {},
  style = {},
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          required={required}
          checked={checked}
          onChange={onToggleChange}
          disabled={disabled}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "#674BF5",
              "&:hover": {
                backgroundColor: "rgba(103, 75, 245, 0.08)",
              },
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#674BF5",
            },
          }}
        />
      }
      label={label + (required ? " *" : "")}
      sx={{
        "& .MuiFormControlLabel-label": {
          fontSize: "0.875rem",
        },
        ...style,
      }}
    />
  );
};
